import React, { Component } from "react";
import "antd/dist/antd.css";
import "../../style.css";
import { Layout, Breadcrumb } from "antd";
import Topbar from "../../component/topbar";
import Sidebar from "../../component/sidebar";
import Switcher from "./switcher";
import MessageAlert from "../../component/messageAlert";
import { connect } from "react-redux";
import { Content, Footer } from "antd/lib/layout/layout";


class PageLayout extends Component {
  state = {};

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  render() {
    return (
      <Layout style={{ minHeight: "100vh" }}>
        {this.props.success ? (
          <MessageAlert type="success" value={this.props.success} />
        ) : null}
        {this.props.error ? (
          <MessageAlert type="error" value={this.props.error} />
        ) : null}
        {this.props.validationError
          ? this.props.validationError.map((item, id) => (
              <MessageAlert type="error" value={item.message} />
            ))
          : null}
        <Topbar />
        <Layout className="site-layout">
          <Sidebar />
          <Layout className="site-layout">
            <Content
              style={{ margin: "0px", padding: "0px", boxShadow: "none" }}
            >
              <Switcher />
            </Content>
            <Footer style={{ textAlign: "center" }}>
              Copyright © 2021-2022 Fakebuzz.net. All rights reserved.
            </Footer>
          </Layout>
        </Layout>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    success: state.message.success,
    error: state.message.error,
    validationError: state.message.validationError,
  };
};
export default connect(mapStateToProps)(PageLayout);
